module.exports = __webpack_public_path__ + "img/2020_11_19_fish_head.8ac084bd.jpg";